var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WidgetNode',{staticClass:"widget-item",class:{ selected: _vm.isWidgetSelected },attrs:{"node":_vm.getWidgetNode(_vm.widget)}})
}
var staticRenderFns = []

export { render, staticRenderFns }